import isEmpty from 'lodash/isEmpty';
import actionTypes from 'dashboard/actions/site-operational-status/action-types';

export default (state = true, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SITE_OPERATIONAL_STATUS_SUCCESS: {
      return isEmpty(action.retailers);
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/site-operational-status/isSiteOperationalStatusEmpty.js